<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">

    <!-- <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert> -->

    <vx-card>

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs class="tab-action-btn-fill-conatiner">
          <vs-tab label="Role Info" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <role-edit-tab class="mt-4" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import RoleEditTab     from './RoleEditTab.vue'

// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    RoleEditTab
  },
  data () {
    return {
      user_data: null,
      user_not_found: false,
      activeTab: 0
    }
  },
  watch: {

  },
  methods: {
    getRoles () {
      fetch(this.$store.state.auth.api_url, {
        method: 'POST', headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          command: 'get_application_roles_list',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token
          }
        })
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (response) => {
              this.$store.commit('userManagement/setRolesList', response.payload)
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((error) => {
          reject(error)
        })
    }
  },
  created () {
    // this.getRoles()
    // this.fetchUserData(this.$route.params.userHash)
  }
}

</script>
